var _g, _path, _g2, _circle, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifyContactMethod(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 288,
    viewBox: "0 0 318 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipVerifyContactMethod0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.722 80.8239V57.2015",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.722 263.148V237.197",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0303 159.01H35.745",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.81 159.01H231.525",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1354 103.67L83.5179 90.1397",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.037 227.77L208.42 214.351",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1354 214.351L83.5179 227.77",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.037 90.1397L208.42 103.67",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1354 103.67L83.5179 90.1397",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.037 227.77L208.42 214.351",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1354 214.351L83.5179 227.77",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.037 90.1397L208.42 103.67",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.478 86.369L118.901 74.946",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.302 50.991L114.213 63.3012",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.253 266.919L181.966 231.652",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6112 188.067L44.1164 202.152",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.174 119.529L261.439 115.869",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.008 124.298L225.832 129.954",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0532 131.507L63.9846 125.961",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2235 118.198L51.1484 121.082",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.332 199.823L226.502 186.514",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.152 232.206L120.799 243.519",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.646 267.917L115.218 258.49",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.034 41.786L180.403 85.7036",
    stroke: "#E4E3FF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8282 85.7351L50.7751 96.7268M38.7154 97.615L49.888 84.8469M251.307 89.653L267.706 94.0866M257.181 100.026L261.833 83.7141M217.453 55.3788C217.777 59.7265 214.463 63.5146 210.049 63.8396C205.636 64.1647 201.795 60.9037 201.47 56.556C201.145 52.2083 204.46 48.4202 208.873 48.0952C213.287 47.7701 217.128 51.0311 217.453 55.3788ZM108.136 39.252C108.378 42.493 105.907 45.3168 102.617 45.5591C99.3273 45.8015 96.4639 43.3705 96.2219 40.1295C95.9799 36.8885 98.4508 34.0647 101.741 33.8224C105.031 33.58 107.894 36.011 108.136 39.252ZM12.486 177.433L11.9803 198.051C12.0123 198.48 12.4803 198.877 12.8948 198.559L31.2876 188.569C31.7128 188.394 31.67 187.821 31.3581 187.556L13.471 176.929C13.0138 176.674 12.4539 177.004 12.486 177.433ZM281.375 163.867L262.883 173.75C262.497 173.956 262.444 174.473 262.776 174.784L280.507 185.662C280.968 185.904 281.482 185.63 281.406 185.182L282.168 164.421C282.289 164.03 281.761 163.661 281.375 163.867Z",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipVerifyContactMethod1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.795 268.134H189.712C201.494 268.134 211.103 258.602 211.103 246.772V101.8C211.103 89.9698 201.494 80.4382 189.712 80.4382H108.795C96.9607 80.4382 87.4038 89.9739 87.4038 101.8V246.772C87.4038 258.598 96.9607 268.134 108.795 268.134Z",
    fill: "white",
    stroke: "#4147EB",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-27-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.013 91.4547L130.29 97.8541C131.253 100.549 133.808 102.329 136.699 102.329H141.711H156.796H161.808C164.651 102.329 167.254 100.549 168.217 97.8541L170.524 91.4547H189.712C195.398 91.4547 200.073 96.0738 200.073 101.8V246.772C200.073 252.45 195.446 257.117 189.712 257.117H108.795C103.109 257.117 98.434 252.498 98.434 246.772V101.8C98.434 96.1219 103.061 91.4547 108.795 91.4547H128.013Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.013 91.4547L130.29 97.8541C131.253 100.549 133.808 102.329 136.699 102.329H141.711H156.796H161.808C164.651 102.329 167.254 100.549 168.217 97.8541L170.524 91.4547H189.712C195.398 91.4547 200.073 96.0738 200.073 101.8V246.772C200.073 252.45 195.446 257.117 189.712 257.117H108.795C103.109 257.117 98.434 252.498 98.434 246.772V101.8C98.434 96.1219 103.061 91.4547 108.795 91.4547H128.013Z",
    fill: "#D2D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.013 91.4547L132.724 89.779L131.542 86.4547H128.013V91.4547ZM130.29 97.8541L125.579 99.5298L125.582 99.5381L130.29 97.8541ZM168.217 97.8541L163.514 96.1588L163.51 96.17L168.217 97.8541ZM170.524 91.4547V86.4547H167.011L165.82 89.7594L170.524 91.4547ZM123.302 93.1304L125.579 99.5298L135 96.1784L132.724 89.779L123.302 93.1304ZM125.582 99.5381C127.269 104.255 131.731 107.329 136.699 107.329V97.3288C135.884 97.3288 135.238 96.8422 134.997 96.17L125.582 99.5381ZM136.699 107.329H141.711V97.3288H136.699V107.329ZM141.711 107.329H156.796V97.3288H141.711V107.329ZM156.796 107.329H161.808V97.3288H156.796V107.329ZM161.808 107.329C166.707 107.329 171.231 104.274 172.925 99.5381L163.51 96.17C163.276 96.8231 162.596 97.3288 161.808 97.3288V107.329ZM172.921 99.5493L175.228 93.1499L165.82 89.7594L163.514 96.1588L172.921 99.5493ZM170.524 96.4547H189.712V86.4547H170.524V96.4547ZM189.712 96.4547C192.66 96.4547 195.073 98.8579 195.073 101.8H205.073C205.073 93.2897 198.137 86.4547 189.712 86.4547V96.4547ZM195.073 101.8V246.772H205.073V101.8H195.073ZM195.073 246.772C195.073 249.696 192.677 252.117 189.712 252.117V262.117C198.215 262.117 205.073 255.204 205.073 246.772H195.073ZM189.712 252.117H108.795V262.117H189.712V252.117ZM108.795 252.117C105.847 252.117 103.434 249.714 103.434 246.772H93.434C93.434 255.282 100.37 262.117 108.795 262.117V252.117ZM103.434 246.772V101.8H93.434V246.772H103.434ZM103.434 101.8C103.434 98.8757 105.83 96.4547 108.795 96.4547V86.4547C100.292 86.4547 93.434 93.3681 93.434 101.8H103.434ZM108.795 96.4547H128.013V86.4547H108.795V96.4547Z",
    fill: "#4147EB",
    mask: "url(#path-27-inside-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.952 149.434H125.808C121.133 149.434 117.374 153.187 117.374 157.854V187.734C117.374 192.402 121.133 196.155 125.808 196.155H132.073V201.062C132.073 203.035 134.145 204.334 135.928 203.42L150.579 196.107H177.952C182.627 196.107 186.386 192.353 186.386 187.686V157.806C186.386 153.187 182.579 149.434 177.952 149.434Z",
    fill: "#4147EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.82 177.005C140.922 177.005 142.627 175.303 142.627 173.203C142.627 171.104 140.922 169.402 138.82 169.402C136.717 169.402 135.012 171.104 135.012 173.203C135.012 175.303 136.717 177.005 138.82 177.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.735 177.005C153.838 177.005 155.543 175.303 155.543 173.203C155.543 171.104 153.838 169.402 151.735 169.402C149.633 169.402 147.928 171.104 147.928 173.203C147.928 175.303 149.633 177.005 151.735 177.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.603 177.005C166.706 177.005 168.41 175.303 168.41 173.203C168.41 171.104 166.706 169.402 164.603 169.402C162.5 169.402 160.796 171.104 160.796 173.203C160.796 175.303 162.5 177.005 164.603 177.005Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 203.754,
    cy: 256.786,
    r: 31,
    fill: "#4147EB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipVerifyContactMethod2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.2 253.406C207.59 253.406 210.338 250.581 210.338 247.096C210.338 243.611 207.59 240.786 204.2 240.786C200.81 240.786 198.061 243.611 198.061 247.096C198.061 250.581 200.81 253.406 204.2 253.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.415 270.786H196.984C195.154 270.786 193.754 269.236 193.754 267.465C193.754 261.487 198.492 256.727 204.2 256.727C210.015 256.727 214.646 261.598 214.646 267.465C214.754 269.347 213.246 270.786 211.415 270.786Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipVerifyContactMethod0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 228,
    fill: "white",
    transform: "translate(33.7534 41.786)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipVerifyContactMethod1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 191,
    fill: "white",
    transform: "translate(85.7535 78.786)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipVerifyContactMethod2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 30,
    fill: "white",
    transform: "translate(193.754 240.786)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyContactMethod);
export default __webpack_public_path__ + "static/media/VerifyContactMethod.5a75294ccc9df45a7c9a8bb8916709e6.svg";
export { ForwardRef as ReactComponent };